import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { CompanyRepository } from '../../../../store/company-state/company-state.repository';
import { Company } from '@/types';

interface getCompanyDataTableStructureProps {
  store: CompanyRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getCompanyDataTableStructure = ({ store, createAction, rowActions }: getCompanyDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const nifColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyInfo.table.nif',
    accessorKey: 'nif',
    variant: DataTableColumnVariant.TEXT,
  };

  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.table.email',
    accessorKey: 'email',
    variant: DataTableColumnVariant.TEXT,
  };

  const firstNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.table.firstName',
    accessorKey: 'responsablePrenom',
    variant: DataTableColumnVariant.TEXT,
  };

  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.table.lastName',
    accessorKey: 'responsableNom',
    variant: DataTableColumnVariant.TEXT,
  };

  const inChargeEmailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.table.emailResponsable',
    accessorKey: 'responsableEmail',
    variant: DataTableColumnVariant.TEXT,
  };

  const countryColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.companyRequests.table.country',
    accessorKey: 'pays',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.companyInfo.table.singular',
    plural: 'settings.companyInfo.table.plural',
    columns: [idColumn, nameColumn, nifColumn, emailColumn, firstNameColumn, lastNameColumn, inChargeEmailColumn, countryColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: Company) => {
      store.set('response', row);
    },
    createAction,
    rowActions,
    searchableFields: ['id', 'nom', 'type.description', 'pays.description', 'nni', 'categorieSoumissionnaire.description'],
  };
};
